import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const targets = ['Vendés productos físicos o servicios.', 'Querés empezar a vender online sin depender de agencias.', 'Te cuesta convertir consultas en ventas.', 'Necesitás una guía práctica, simple y aplicable.', 'Querés aprovechar IA, Meta Ads y WhatsApp sin perder tiempo viendo contenido suelto.', 'Buscás un sistema ordenado para lanzar, probar y mejorar.'];
export function ForWhomSection() {
  return <section className="py-10 sm:py-20 px-4 bg-green-950/20" data-id="element-100">
      <div className="max-w-4xl mx-auto" data-id="element-101">
        <motion.div initial={{
        opacity: 0,
        y: 5
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-10px'
      }} transition={{
        duration: 0.2
      }} data-id="element-102">
          <h2 className="text-3xl sm:text-4xl font-black text-center text-white mb-8 sm:mb-12 drop-shadow-lg uppercase" data-id="element-103">
            ESTE MÉTODO ES PARA VOS SI:
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6" data-id="element-104">
            {targets.map((target, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.98
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true,
            margin: '-20px'
          }} transition={{
            duration: 0.2,
            delay: index * 0.05
          }} className="flex items-center gap-4 bg-green-900/30 p-5 rounded-xl border border-green-600/20" data-id="element-105">
                <CheckCircle2 className="w-6 h-6 text-yellow-300 shrink-0" data-id="element-106" />
                <span className="text-lg text-white font-medium" data-id="element-107">{target}</span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}